<h1 mat-dialog-title> Valida Postulación Ayuda Médica </h1> <br />

<mat-dialog-content>

    <p>
        <mat-form-field appearance="outline" class="mat-input">
            <p>Titular</p>
            <input *ngIf="!data.carga" matInput [disabled]="true" [value]="data.beneficiario" />
            <br /> <br />
            <p> Beneficiario</p>
            <input *ngIf="!data.carga" matInput [disabled]="true" [value]="data.datoBeneficiario" />
        </mat-form-field>
    </p>
    <!--
    <div class="table-responsive" *ngIf="data.mostrarTitularCarga == true">

        <table class="table">

            <thead style="background-color: #0f69b4;color:white;">

                <tr>
                    <th scope="col"> Rut </th>

                    <th scope="col"> Nombre y Apellidos </th>

                    <th scope="col"> Parentesco </th>

                    <th scope="col"> Edad </th>

                    <th scope="col"> Sexo </th>

                    <th scope="col"> Seleccionar </th>
                </tr>

            </thead>

            <tbody *ngIf="data.mostrarTitularCarga == true">

                <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'"
                    *ngFor="let postulante of data.postulantes; let i = index">

                    <td> {{postulante.rut + '-' + postulante.dv}} </td>

                    <td> {{postulante.nombres + ' ' + postulante.apellidoPaterno }} </td>

                    <td> {{postulante.parentesco}} </td>

                    <td> {{postulante.fechaNacimiento}} </td>

                    <td> {{postulante.sexo.nombre}} </td>

                    <td>

                        <input type="radio" [checked]="(postulante.id==data.idCarga)" [disabled]="true"
                            name="postulante" (click)="esconderBeneficiarios(postulante.parentesco)">

                    </td>

                </tr>

            </tbody>

        </table>

    </div>
    <br />
    -->
    <div class="row">

        <div class="col-lg-1"> </div>

        <div class="col-lg-8">
            <h2> Datos Ayuda Médica </h2>
        </div>

        <div class="col-lg-3"> </div>

    </div>
    <br />

    <div class="row" *ngIf="data.mostrarBeneficiarios == true">
        <div class="col-lg-2" *ngIf="data.mostrarBeneficiarios == true">
            <h2> Beneficiarios: </h2>
        </div>
        <div class="col-lg-9" *ngIf="data.mostrarBeneficiarios == true">
        </div>
    </div>


    <!--      <div class="table-responsive"  *ngIf="data.mostrarBeneficiarios == true">  -->
    <div class="table-responsive">
        <table class="table">
            <thead style="background-color: #0f69b4;color:white;">
                <tr>
                    <th scope="col"> Id</th>
                    <th scope="col"> monto Total Gasto </th>
                    <th scope="col"> monto Reembolso </th>
                    <th scope="col"> monto Reembolso Sistema </th>
                    <th scope="col"> monto Otro Reembolso </th>
                    <th scope="col"> Monto Copago Total</th>
                    <th scope="col"> Num. documento </th>
                    <th scope="col"> Diagnóstico </th>
                    <th scope="col"> Tratamiento </th>
                    <th scope="col"> Editar </th>
                    <th scope="col"> Eliminar </th>
                </tr>
            </thead>

            <tbody>
                <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'"
                    *ngFor="let docu of data.documentosAyuda | paginate: data.config; let i = index">

                    <td style="text-align: left;">{{docu.idDocumentoAyudaMedica}}</td>
                    <td style="text-align: left;">{{docu.montoTotalGasto}}</td>
                    <td style="text-align: left;">{{docu.montoReembolso}}</td>
                    <td style="text-align: left;">{{docu.montoReembolsoSistema}}</td>
                    <td style="text-align: left;">{{docu.montoOtroReembolso}}</td>
                    <td style="text-align: left;">{{docu.montoCopago}}</td>
                    <td style="text-align: left;">{{docu.nroDocumento}}</td>
                    <td style="text-align: left;">{{docu.diagnostico|slice:0:12}}</td>
                    <td style="text-align: left;">{{docu.tratamiento|slice:0:12}}</td>
                
                    <td style="text-align: left;"  *ngIf="data.mostrarEditar"> 
                        <button class="btn btn-warning" [disabled]="data.deshabilitado"
                            (click)="onMuestraDocumento(docu.idDocumentoAyudaMedica,docu.idAyudaMedica)"
                            style="width:90px">
                            <i class="fa fa-pen"> </i> Editar
                        </button>
                    </td>
                    <td style="text-align: left;"  *ngIf="!data.mostrarEditar"> 
                        <button class="btn btn-warning" 
                            (click)="onMuestraDocumento(docu.idDocumentoAyudaMedica,docu.idAyudaMedica)"
                            style="width:90px">
                            <i class="fa fa-pen"> </i> Ver
                        </button>
                    </td>
                    <td style="text-align: left;"> <button class="btn btn-danger" [disabled]="data.deshabilitado"
                            (click)="onEliminarDocumento(docu.idDocumentoAyudaMedica,docu.idAyudaMedica)"
                            style="width:110px">
                            <i class="fa fa-pen"> </i> Eliminar
                        </button>
                    </td>

                </tr>
            </tbody>
        </table>
    </div>
    <br />

    <p>

    <div class="table-responsive" *ngIf="data.mostrarDocumento == true">
        <form #documentoAudaForm=ngForm>
            <div class="row input-container">
                <div class="col-md-6 col-sm-12">
                    <div class="styled-input"> <mat-select [(ngModel)]="data.documentosAyudaEdit.idTipoEvento" required
                            id="tipoEvento" name="tipoEvento" #tipoEvento="ngModel"
                            [(value)]="data.documentosAyudaEdit.idTipoEvento"
                            ng-model-options="{updateOn: 'submit'}">

                            <mat-option *ngFor="let evento of this.data.eventos" [value]="evento.id">

                                {{evento.descripcion}}

                            </mat-option>

                        </mat-select> <label>Tipo de Evento</label>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="styled-input" style="float:center;">
                        <mat-select name="tipoDocumento" id="tipoDocumento" class="form-control" required
                            [(ngModel)]="data.documentosAyudaEdit.tipoDocumento" #tipoDocumento="ngModel"
                            ng-model-options="{updateOn: 'submit'}">

                            <mat-option *ngFor="let tipoDocumento of this.data.tiposDocumento"
                                value="{{tipoDocumento}}">

                                {{tipoDocumento}}

                            </mat-option>

                        </mat-select>
                        <label> Tipo de Documento </label>
                    </div>
                </div>

                <div class="col-md-6 col-sm-12">
                    <div class="styled-input">
                        <input class="form-control" name="fechaDocumento" id="fechaDocumento" required
                            #fechaDocumento="ngModel" [(ngModel)]="data.documentosAyudaEdit.fechaDocumento" type="date"
                            ng-model-options="{updateOn: 'submit'}">
                        <label>Fecha de Documento </label>
                    </div>
                </div>
                <div class="col-md-4 col-sm-8">
                    <div class="styled-input">
                        <input class="form-control" name="nroDocumento" required #nroDocumento="ngModel"
                            [(ngModel)]="data.documentosAyudaEdit.nroDocumento" type="number"
                            (keypress)="numberOnly($event)" autocomplete=off onPaste="return false">
                        <label>Folio de Documento </label>
                    </div>
                </div>

                <div class="col-md-4 col-sm-8">
                    <div class="styled-input" style="float:left;">
                        <input id="rutPrestador" name="rutPrestador" [(ngModel)]="data.documentosAyudaEdit.rutPrestador"
                            #rutPrestador="ngModel" class="form-control" type="text" required type="text"
                            placeholder="Ingrese el RUT del prestador. Ej: 11111111-1"
                            pattern="[0-9]{7,10}[-]{1}[0-9Kk]{1}" />
                        <label>rut Prestador </label>
                    </div>
                </div>

                <div class="col-md-4 col-sm-8">
                    <div class="styled-input" style="float:right;">
                        <mat-select name="sistemaSalud" class="form-control" required (selectionChange)="muestraOtro()"
                            [(ngModel)]="data.documentosAyudaEdit.sistemaSalud"
                            [(value)]="data.documentosAyudaEdit.sistemaSalud" #sistemaSalud="ngModel">
                            <mat-option *ngFor="let sis of this.data.sistema" [value]="sis.id">
                                {{sis.descripcion}}
                            </mat-option>

                        </mat-select>
                        <label> Sistema de Salud </label>
                    </div>
                </div>
                <div *ngIf="data.otro ==true" class="col-md-4 col-sm-8">
                    <div class="styled-input" style="float:center;">
                        <input id="otroSistemaSalud" name="otroSistemaSalud"
                            [(ngModel)]="data.documentosAyudaEdit.otroSistemaSalud" #rutPrestador="ngModel"
                            class="form-control" type="text" type="text"
                            placeholder="Ingrese otro tipo de Sistema de Salud" />
                        <label>Otro Sistema de Salud</label>
                    </div>
                </div>


                <div class="col-md-6 col-sm-12">
                    <div class="styled-input">
                        <textarea name="diagnostico" style="border: 1px solid #ced4da;" id="diagnostico" [(ngModel)]="data.documentosAyudaEdit.diagnostico" class="form-control"
                         cols="30" rows="3">
                        </textarea>

                        <label>Diagnóstico</label>
                    </div>
                </div>
              
                <div class="col-md-6 col-sm-12">
                    <div class="styled-input" style="float:center;">
                        <textarea name="tratamiento" id="tratamiento" style="border: 1px solid #ced4da;" [(ngModel)]="data.documentosAyudaEdit.tratamiento" class="form-control"
                        cols="30" rows="3">
                       </textarea>

                        <label>Tratamiento</label>
                    </div>
                </div>

                <div class="col-md-6 col-sm-12">
                    <div class="styled-input">
                        <mat-select name="proteccionSalud" [(value)]="data.documentosAyudaEdit.proteccionSaludArray"
                            class="form-control" required multiple
                            [(ngModel)]="data.documentosAyudaEdit.proteccionSaludArray" #proteccionSalud="ngModel"
                            (selectionChange)="muestraOtroProteccionSalud()">

                            <mat-option *ngFor="let pro of this.data.proteccion" [value]="pro.id">
                                {{pro.descripcion}}
                            </mat-option>

                        </mat-select>
                        <label>Protección de Salud </label>
                    </div>
                </div>


                <div class="col-md-6 col-sm-12" *ngIf="data.otroProteccionSalud ==true">
                    <div class="styled-input" style="float:center;">
                        <input id="otroProteccion" name="otroProteccion"
                            [(ngModel)]="data.documentosAyudaEdit.otroProteccion" #otroProteccion="ngModel"
                            class="form-control" type="text" placeholder="Ingrese otro tipo de Protección de Salud" />
                        <label>Otro Protección de Salud</label>
                    </div>
                </div>

                <div class="col-md-4 col-sm-8">
                    <div class="styled-input">
                        <input class="form-control" name="montoTotalGasto" id="montoTotalGasto" required type="number"
                            autocomplete=off (keypress)="numberOnly($event)" #montoTotalGasto="ngModel"
                            [(ngModel)]="data.documentosAyudaEdit.montoTotalGasto" (change)="calculaMontoCopago()">

                        <label>Monto Total del Gasto</label>
                    </div>
                </div>
                <div class="col-md-4 col-sm-8">
                    <div class="styled-input" style="float:right;">
                        <input class="form-control" name="montoReembolso" id="montoReembolso" required type="number"
                            autocomplete=off (keypress)="numberOnly($event)" #montoReembolso="ngModel"
                            [(ngModel)]="data.documentosAyudaEdit.montoReembolso" (change)="calculaMontoCopago()">

                        <label>Monto Reembolso Sistema Salud (Fonasa/Isapre)</label>
                    </div>
                </div>

                <div class="col-md-4 col-sm-8">
                    <div class="styled-input">
                        <input class="form-control" name="montoReembolsoSistema" id="montoReembolsoSistema" required
                            type="number" autocomplete=off (keypress)="numberOnly($event)"
                            #montoReembolsoSistema="ngModel"
                            [(ngModel)]="data.documentosAyudaEdit.montoReembolsoSistema" (change)="calculaMontoCopago()"
                            placeholder=0>
                        <label>Monto Reembolso de Bienestar o Cía. Seguro </label>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="styled-input" style="float:right;">
                        <input class="form-control" name="montoOtroReembolso" id="montoOtroReembolso" required
                            type="number" autocomplete=off (keypress)="numberOnly($event)" #montoOtroReembolso="ngModel"
                            [(ngModel)]="data.documentosAyudaEdit.montoOtroReembolso" (change)="calculaMontoCopago()"
                            placeholder=0>

                        <label>Monto Otro Reembolso</label>
                    </div>
                </div>
                <div class="col-md-6 col-sm-12">
                    <div class="styled-input">
                        <input class="form-control" name="montoCopago" id="montoCopago" required #montoCopago="ngModel"
                            [(ngModel)]="data.documentosAyudaEdit.montoCopago" type="number"
                            (keypress)="numberOnly($event)" autocomplete=off disabled value="ayuda.montoCopago">
                        <label>Monto Copago Total</label>
                    </div>
                </div>

                <div class="col-lg-12">    
                     <td class="col-lg-3"></td> 
                     <td class="col-lg-3"></td> 
                     <td class="col-lg-2" style = "text-align:center;" >
                        <button *ngIf="data.mostrarEditar" mat-button class="mat-raised-button btn-success" title="Guardar" alt="Guardar"
                            (click)="onGuardarEditClick(data.documentosAyudaEdit.idAyudaMedica)">
                            <i > </i>Guardar 
                        </button>       &nbsp;              
                        <button mat-button class="mat-raised-button btn-danger" title="Cerrar" alt="Cerrar" (click)="onCerrarEditClick()">
                            <i> </i> Cerrar 
                        </button>
                    </td>                    
                 </div>             
                 <br />
           
            </div>
            <br />
        </form>
    </div>


    <div class="table-responsive">
        <form #ayudaForm=ngForm>
            <div class="row ">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Monto Total Copago </p>
                </div>

                <div class="col-lg-5">

                    <input class="form-control" name="totalCopago" [(ngModel)]="data.totalCopago" type="number"
                        (keypress)="numberOnly($event)" autocomplete=off disabled>

                </div>
                <div class="col-lg-3"> </div>

            </div>
            <br />
            <div class="row" *ngIf="data.stringTipoEvento!='DENTAL'">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Porcentaje Rebaja % </p>
                </div>

                <div class="col-lg-5">

                    <input class="form-control" name="porcentajeRebaja"  [(ngModel)]="data.porcentajeRebaja" type="number" (keypress)="numberOnly($event)"
                        placeholder="Ingrese porcentaje (1-100)" max="100" (keypress)="validateFormat($event)"  (change)="calculaTotalaPagar($event)"
                        [disabled]="data.deshabilitadoObs" autocomplete=off>
                </div>
                <div class="col-lg-3"> </div>

            </div>
            <br />
            <div class="row">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Total a pagar </p>
                </div>

                <div class="col-lg-5">

                    <input class="form-control" name="totalPagar" [(ngModel)]="data.totalPagar" type="number"
                        (keypress)="numberOnly($event)" autocomplete=off disabled>

                </div>

                <div class="col-lg-3"> </div>

            </div>
            <br />

            <div class="row">
                <div class="col-lg-1"> </div>
                <div class="col-lg-3"> <label>Observación</label> </div>
                <div class="col-lg-5">
                    <textarea name="observacion" style="border: 1px solid #ced4da;" id="observacion" [(ngModel)]="data.observacion" class="form-control"
                        [disabled]="data.deshabilitadoObs" required cols="40" rows="5" maxlength="500" >
                </textarea>
                </div>
                <div class="col-lg-3"> </div>
            </div>
            <br />




            <p>
                <button class="btn-info mat-raised-button" (click)="onDescargarArchivosClick(data.idPostulacion)">

                    <i class="fa fa-download"> </i> Descargar Archivos Ingresado </button>
            </p>


            <div class="row ">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo" required
                        accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="data.archivoTest"
                        (change)="seleccionaArchivo($event, 0)" [disabled]="data.deshabilitado">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button [disabled]="data.deshabilitado" class="btn btn-info"
                        (click)="sumaArchivo()"> + </button> </div>
                <div class="col-lg-1"> </div>

            </div>
            <br />

            <div *ngIf="data.cantidadArchivos > 1" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (2) </p>
                </div>

                <div class="col-lg-5">
                    <input type="file" class="form-control-file" name="archivo2" required
                        accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="data.archivoTest2"
                        (change)="seleccionaArchivo($event, 1)">
                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>
            <br />
            <div *ngIf="data.cantidadArchivos > 2" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (3) </p>
                </div>

                <div class="col-lg-5">
                    <input type="file" class="form-control-file" name="archivo3" required
                        accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="data.archivoTest3"
                        (change)="seleccionaArchivo($event, 2)">
                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>
            <br />
            <div *ngIf="data.cantidadArchivos > 3" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (4) </p>
                </div>

                <div class="col-lg-5">
                    <input type="file" class="form-control-file" name="archivo4" required
                        accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="data.archivoTest4"
                        (change)="seleccionaArchivo($event, 3)">

                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>
            <br />
            <div *ngIf="data.cantidadArchivos > 4" class="row line">

                <div class="col-lg-1"> </div>

                <div class="col-lg-3">
                    <p> Adjuntar (5) </p>
                </div>

                <div class="col-lg-5">

                    <input type="file" class="form-control-file" name="archivo5" required
                        accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="data.archivoTest5"
                        (change)="seleccionaArchivo($event, 4)">
                </div>

                <div class="col-lg-1"> </div>

                <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

                <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

            </div>

        </form>
    </div>

</mat-dialog-content> <br />

<mat-dialog-actions>
    <div *ngIf="data.rol != 'ROLE_EJECUTIVO_CAIP';  else roleReadOnly">
        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button
            class="mat-raised-button btn-warning" (click)="onEditarClick()">
            <i class="fa fa-pen"> </i> Editar
        </button>

        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.mostrarAprobarButton" mat-button
            class="mat-raised-button btn-success" (click)="onAprobarClick()">
            <i class="fa fa-check"> </i> Aprobar
        </button>

        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button
            class="mat-raised-button btn-danger" (click)="onRechazarClick()">
            <i class="fa fa-times"> </i> Rechazar
        </button>

        <button *ngIf="data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button
            class="mat-raised-button btn-success" (click)="onGuardarClick()">
            <i class="fa fa-download"> </i> Guardar
        </button>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class="fa fa-trash"> </i> Salir
        </button>
    </div>

    <ng-template #roleReadOnly>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class="fa fa-trash"> </i> Salir
        </button>
    </ng-template>

</mat-dialog-actions>